export default "/252dp_logo.55b2bd8b-2a5c0d.gif";